import swiper from 'swiper';

let slide = $(".js-list-residence .swiper-slide").length;
if(slide < 4) {
  $('.c-list-residence-wrapper').addClass('is-limit');
}


var categoryListCoin = new swiper ('.js-list-residence', {
  // Optional parameters
  direction: 'horizontal',
  loop: false,
  slidesPerView: 3,
  speed: 400,
  autoplay: true,
  spaceBetween: 40,
  // observer: true,
  // freeModeSticky: true,
  // freeModeMomentumVelocityRatio: 10,
  // freeModeMomentumRatio: 10,
  // observeParents: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    599: {
      slidesPerView: 1.4,
      spaceBetween: 15,
      centeredSlides: true,
    }
  },
  preloadImages: false,
  noSwiping: false,
  // slidesPerView: 'auto',
  autoHeight: false,
  allowTouchMove: true,
  navigation: {
    nextEl: '.swiper-residence-next',
    prevEl: '.swiper-residence-prev',
  }

});
